import React, { createContext, useContext, useState } from "react";
import RespondPopup from "./RespondPopup";

type PopupContextType = {
  show: (showEmail: boolean) => void;
  hide: () => void;
};

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const usePopup = () => {
  const ctx = useContext(PopupContext);
  if (!ctx) throw new Error("usePopup must be used within a PopupProvider");
  return ctx;
};

export const PopupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [showEmail, setShowEmail] = useState(false);

  const show = (email) => {
    setShowEmail(email);
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const includeEmail = () => {};

  return (
    <PopupContext.Provider value={{ show, hide }}>
      {children}
      <RespondPopup visible={visible} showEmail={showEmail} />
    </PopupContext.Provider>
  );
};
